import {Observable} from 'rxjs';
import {
  AbstractStorageUnitDialogsManagerService,
  NewStorageUnitDialogResult,
  SheetLabelPrintDialogComponent,
  SheetLabelPrintDialogData
} from '|shared';
import {inject, Injectable} from '@angular/core';
import {
  NewStorageUnitDialogComponent,
  NewStorageUnitDialogData,
} from '../components/new-storage-unit-dialog/new-storage-unit-dialog.component';
import {
  StorageUnitInsertDialogComponent,
  StorageUnitInsertDialogData
} from '../components/storage-unit-insert-dialog/storage-unit-insert-dialog.component';
import {StorageUnitDto} from '|api/document';
import {IczModalService, IczModalSizeClass} from '@icz/angular-modal';

@Injectable()
export class StorageUnitDialogsManagerService implements AbstractStorageUnitDialogsManagerService {

  private modalService = inject(IczModalService);

  openStorageUnitCreateDialog(fileCabinetId?: Nullable<number>, fileCabinetName?: Nullable<string>) {
    return this.modalService.openComponentInModal<NewStorageUnitDialogResult, NewStorageUnitDialogData>({
      component: NewStorageUnitDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: 'Nová ukládací jednotka',
        disableAutoMargin: true,
      },
      data: {
        fileCabinetId,
        fileCabinetName,
      },
    });
  }

  openStorageUnitInsertDialog(storageUnit: StorageUnitDto): Observable<boolean> {
    return this.modalService.openComponentInModal<boolean, StorageUnitInsertDialogData>({
      component: StorageUnitInsertDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: 'Vložení do {{storageUnitNumber}} - {{storageUnitName}}',
        titleTemplateContext: {
          storageUnitNumber: storageUnit.storageUnitNumber,
          storageUnitName: storageUnit.name,
        },
        disableAutoMargin: true,
      },
      data: {
        storageUnit,
        isMove: false,
      }
    });
  }

  printSheetLabels(selection: StorageUnitDto[]): Observable<Nullable<boolean>> {
    const isBulkAction = selection.length > 1;

    return this.modalService.openComponentInModal<boolean, SheetLabelPrintDialogData>({
      component: SheetLabelPrintDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: isBulkAction ? 'Tisk etiket ({{count}})' : 'Tisk etikety',
        titleTemplateContext: {
          count: selection.length,
        },
        disableAutoMargin: isBulkAction,
      },
      data: {
        objects: selection,
      },
    });
  }

}
